import { IMentionsResponse } from './../../common/types/mentions.types'
import { get, useHttp } from 'hooks/use-http/useHttp'

export const fetchSearchMentionablesResult = async (page = 1, pageSize = 5, searchQuery?: string, userId?: string) => {
  const response = await get(
    `search/mentions/user/${userId}?page=${page}&pageSize=${pageSize}&dir=asc&name=${searchQuery ? searchQuery : ''}`,
    {
      dieSilent: true
    }
  )

  return response as IMentionsResponse
}

export const fetchSearchResultsForChannelAdminByNameQuery = async (
  page = 1,
  pageSize = 5,
  searchQuery: string,
  userId: string,
  channelId: string
) => {
  const response = await get(
    `channel/admin/${userId}/channel/${channelId}/search?page=${page}&pageSize=${pageSize}&dir=asc&name=${
      searchQuery ? searchQuery : ''
    }`,
    {
      dieSilent: true
    }
  )

  return response as IMentionsResponse
}

export const useMentionsApi = () => {
  return {
    fetchSearchMentionablesResult,
    fetchSearchResultsForChannelAdminByNameQuery
  } as const
}
